<template>
  <v-container>
    <v-row v-if="resultadosPersonal.length == 0" justify="center">
      <v-col cols="4">
        <v-card class="ui-module-card ui-module-fade-in-up" color="primary">
          <v-card-title class="justify-center font-weight-bold ui-module-titlebar">Buscar personal</v-card-title>
          <v-card-text>
            <v-text-field
              v-model="busquedaPersonal.nombre"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Nombre"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.segundoNombre"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Segundo nombre"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.apaterno"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Apellido paterno"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.amaterno"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="Apellido materno"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.curp"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="CURP"
            ></v-text-field>
            <v-text-field
              v-model="busquedaPersonal.CUIP"
              color="secondary"
              background-color="primary"
              rounded
              filled
              label="CUIP"
            ></v-text-field>
          </v-card-text>
          <v-card-actions class="justify-center pb-8 ui-module-actions">
            <v-container class="py-0">
              <v-row justify="center">
                <v-col cols="8" align="center">
                  <TextButton
                    block
                    large
                    class="btn-search-modern ui-module-btn-solid"
                    @click="triggerSearchPersonal()"
                    :disabled="loading || emptyForm"
                    :loading="loading"
                    >Realizar búsqueda</TextButton
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <v-row v-else align="start">
      <v-col cols="12">
        <v-row>
          <v-col cols="4">
            <TextButton @click="RESET_BUSQUEDA_PERSONAL()">Realizar nueva búsqueda</TextButton>
          </v-col>
          <v-spacer></v-spacer>
          <v-col cols="4">
            <v-text-field
              label="Filtrar elementos"
              v-model="filtroPersonal"
              rounded
              filled
              dense
              color="secondary"
              background-color="primary"
            ></v-text-field>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" lg="4" xl="3" v-for="personal in filteredPersonal" :key="personal.id">
        <v-card class="ui-module-card ui-module-fade-in-up" color="secondary" elevation="8">
          <v-card-title>
            <v-container>
              <v-row>
                <v-col cols="12" align="center">
                  <v-avatar rounded color="primary" size="80" v-if="!personal.foto">
                    <v-icon x-large color="secondary">mdi-account</v-icon>
                  </v-avatar>
                  <v-img
                    v-else
                    :src="personal.foto"
                    max-height="80"
                    max-width="80"
                    @error="personal.foto = null"
                  ></v-img>
                </v-col>
                <v-col cols="12" align="center">
                  <div class="text-h6 primary--text font-weight-bold">{{ personal.apaterno }}</div>
                  <div class="text-subtitle-1 primary--text">
                    {{ personal.amaterno + ' ' + personal.nombre + ' ' + personal.segundoNombre }}
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </v-card-title>
          <v-card-text>
            <div class="text-subtitle-1 primary--text font-weight-bold mb-2">Vigencias</div>
            <v-row>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">CUP</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFechaAjustada(personal.vigenciaCup) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaCup)"
                      tipoRegla="desarrollo"
                      nombreVigencia="CUP"
                      :fechaVigencia="getFechaVigenciaAjustada(personal.vigenciaCup)"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">Evaluación C3</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFechaAjustada(personal.vigenciaEvaluacionC3) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaEvaluacionC3)"
                      tipoRegla="desarrollo"
                      nombreVigencia="Evaluación C3"
                      :fechaVigencia="getFechaVigenciaAjustada(personal.vigenciaEvaluacionC3)"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">Competencias básicas</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFechaAjustada(personal.vigenciaCompetenciasBasicas) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaCompetenciasBasicas)"
                      tipoRegla="desarrollo"
                      nombreVigencia="Competencias básicas"
                      :fechaVigencia="getFechaVigenciaAjustada(personal.vigenciaCompetenciasBasicas)"
                    />
                  </v-col>
                </v-row>
              </v-col>
              <v-col cols="12">
                <v-row align="center" no-gutters>
                  <v-col class="pa-0" cols="6">
                    <div class="text-caption primary--text">Formación inicial</div>
                    <div class="text-subtitle-2 primary--text">
                      {{ formatFechaAjustada(personal.vigenciaFormacionInicial) }}
                    </div>
                  </v-col>
                  <v-col class="pa-0" cols="6" align="right">
                    <Semaforo
                      :meses="getMesesRestantes(personal.vigenciaFormacionInicial)"
                      tipoRegla="desarrollo"
                      nombreVigencia="Formación inicial"
                      :fechaVigencia="getFechaVigenciaAjustada(personal.vigenciaFormacionInicial)"
                    />
                  </v-col>
                </v-row>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="secondary darken-1 ui-module-actions">
            <v-container>
              <v-row>
                <v-col cols="12" align="right">
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.CONDECORAR_ELEMENTO)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action mr-1"
                        elevation="8"
                        icon
                        v-on="on"
                        v-bind="attrs"
                        @click="openCondecoracionPersonalDialog(personal)"
                      ><v-icon>mdi-medal</v-icon></v-btn>
                    </template>
                    <span>Condecorar a este elemento</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.REALIZAR_EVALUACION_ANUAL)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action mr-1"
                        elevation="8"
                        icon
                        :to="{
                          path: 'evaluacion_desempenio_anual/' + personal.idPersonal,
                          params: { idPersonalEvaluado: personal.idPersonal },
                        }"
                        v-on="on"
                        v-bind="attrs"
                      ><v-icon>mdi-numeric-1-circle</v-icon></v-btn>
                    </template>
                    <span>Realizar evaluación anual</span>
                  </v-tooltip>
                  <v-tooltip
                    bottom
                    color="black"
                    v-if="hasAccessToFeature(perfil, FEATURES.REALIZAR_EVALUACION_DESEMPEÑO)"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action mr-1"
                        elevation="8"
                        icon
                        :to="{
                          path: 'evaluacion_desempenio/' + personal.idPersonal,
                          params: { id: personal.idPersonal },
                        }"
                        v-on="on"
                        v-bind="attrs"
                      ><v-icon>mdi-numeric-3-circle</v-icon></v-btn>
                    </template>
                    <span>Realizar evaluación de desempeño</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.SUGERIR_CURSO)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action mr-1"
                        elevation="8"
                        icon
                        :to="{ name: 'sugerirCurso', params: { personal: personal } }"
                        v-on="on"
                        v-bind="attrs"
                      ><v-icon>mdi-comment-quote</v-icon></v-btn>
                    </template>
                    <span>Sugerir curso</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black" v-if="hasAccessToFeature(perfil, FEATURES.ASIGNACION_CUP)">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action mr-1"
                        elevation="8"
                        icon
                        :to="{ name: 'asignaCup', params: { personal: personal } }"
                        v-on="on"
                        v-bind="attrs"
                      ><v-icon>mdi-card-bulleted</v-icon></v-btn>
                    </template>
                    <span>Asignación de CUP</span>
                  </v-tooltip>
                  <v-tooltip bottom color="black">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        class="primary secondary--text ui-module-icon-action mr-1"
                        elevation="8"
                        icon
                        :to="{
                          name: 'documentosPersonalDesarrollo',
                          params: { id: personal.idPersonal },
                        }"
                        v-on="on"
                        v-bind="attrs"
                      ><v-icon>mdi-file-account</v-icon></v-btn>
                    </template>
                    <span>Ver expediente del personal</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-container>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
    <asigna-condecoracion-personal-dialog-component
      :active="condecoracionPersonalDialog"
      :personal="selectedPersonal"
      @close="condecoracionPersonalDialog = false"
    ></asigna-condecoracion-personal-dialog-component>
  </v-container>
</template>
<style scoped>
.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
<script>
import { mapGetters, mapActions, mapMutations } from 'vuex'
import _ from 'lodash'
import AsignaCondecoracionPersonalDialogComponent from '../../components/desarrollo_policial/condecoraciones/AsignaCondecoracionPersonalDialogComponent.vue'
import IconRoundedButton from '@/components/base/IconRoundedButton.vue'
import Semaforo from '@/components/SemaforoComponent.vue'
import TextButton from '../../components/base/TextButton.vue'
import moment from 'moment'

export default {
  components: {
    AsignaCondecoracionPersonalDialogComponent,
    IconRoundedButton,
    Semaforo,
    TextButton,
  },

  data() {
    return {
      loading: false,
      filtroPersonal: '',
      selectedPersonal: null,
      condecoracionPersonalDialog: false,
    }
  },

  computed: {
    ...mapGetters({
      perfil: 'getPerfil',
    }),

    ...mapGetters('personal', {
      resultadosPersonal: 'getPersonal',
      busquedaPersonal: 'getBusquedaPersonal',
    }),

    ...mapGetters('tipoAmbito', {
      tipoAmbito: 'getTipoAmbito',
    }),

    ...mapGetters('dependencia', {
      dependencias: 'getDependencias',
    }),

    filteredPersonal: function () {
      return this.resultadosPersonal.filter((personal) => {
        return (
          this.getFullName(personal).toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.CUIP.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.rfc.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0 ||
          personal.curp.toLowerCase().indexOf(this.filtroPersonal.toLowerCase()) >= 0
        )
      })
    },

    emptyForm() {
      if (
        this.busquedaPersonal.nombre === '' &&
        this.busquedaPersonal.segundoNombre === '' &&
        this.busquedaPersonal.apaterno === '' &&
        this.busquedaPersonal.amaterno === '' &&
        this.busquedaPersonal.curp === '' &&
        this.busquedaPersonal.CUIP === ''
      ) {
        return true
      } else return false
    },
  },

  methods: {
    ...mapActions('personal', ['searchPersonal']),
    ...mapMutations(['SET_SNACKBAR_MESSAGE']),
    ...mapMutations('personal', ['RESET_BUSQUEDA_PERSONAL']),

    getMesesRestantes(fechaVigencia) {
      const fechaAjustada = this.getFechaVigenciaAjustada(fechaVigencia)
      if (!fechaAjustada) return null
      const fechaMoment = require('moment')(fechaAjustada, 'YYYY-MM-DD', true)
      if (!fechaMoment.isValid()) return null
      const meses = fechaMoment.diff(require('moment')(), 'months', true)

      return meses >= 0 ? meses : 0
    },
    formatFechaAjustada(fecha) {
      const fechaAjustada = this.getFechaVigenciaAjustada(fecha)
      if (!fechaAjustada) return 'No registrada'
      return moment(fechaAjustada, 'YYYY-MM-DD').format('DD/MM/YYYY')
    },

    getFechaVigenciaAjustada(fecha) {
      if (!fecha) return null
      let formato = 'YYYY-MM-DD'
      if (/^\d{2}\/\d{2}\/\d{4}$/.test(fecha)) {
        formato = 'DD/MM/YYYY'
      }
      const fechaMoment = require('moment')(fecha, formato, true)
      if (!fechaMoment.isValid()) return null
      return fechaMoment.add(3, 'years').format('YYYY-MM-DD')
    },

    async triggerSearchPersonal() {
      this.loading = true

      await this.searchPersonal(this.busquedaPersonal)
      if (this.resultadosPersonal.length == 0) {
        this.SET_SNACKBAR_MESSAGE('Búsqueda sin resultados.')
      }

      this.loading = false
    },

    openCondecoracionPersonalDialog(personal) {
      this.selectedPersonal = personal
      this.condecoracionPersonalDialog = true
      this.loading = false
    },
  },
}
</script>
<style scoped>
/* Estilos modernos para Personal Desarrollo Profesional */
.ui-module-card {
  background: rgba(26, 46, 36, 0.6) !important;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2);
  border-radius: 20px;
  box-shadow: 0 8px 32px rgba(0, 0, 0, 0.3);
  transition: all 0.3s ease;
}

.ui-module-card:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
  transform: translateY(-4px) scale(1.02);
  box-shadow: 0 12px 32px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3) !important;
}

/* Card title */
::v-deep .v-card-title {
  color: #1a1a1a !important;
  padding: 16px;
  background: rgba(0, 0, 0, 0.08);
  border-bottom: 1px solid rgba(0, 0, 0, 0.2);
}

/* Card text */
::v-deep .v-card-text {
  color: #1a1a1a !important;
  padding: 16px;
}

/* Card actions */
::v-deep .v-card-actions {
  background: rgba(0, 0, 0, 0.08) !important;
  border-top: 1px solid rgba(0, 0, 0, 0.1);
  padding: 12px 16px !important;
}

/* Títulos y textos */
.text-h6.font-weight-bold {
  color: #1a1a1a !important;
  text-shadow: 0 1px 2px rgba(255, 255, 255, 0.2);
}

.primary--text {
  color: rgba(26, 26, 26, 0.9) !important;
}

.text-subtitle-1.primary--text {
  color: rgba(26, 26, 26, 0.8) !important;
}

.text-caption.primary--text {
  color: rgba(26, 26, 26, 0.75) !important;
  font-weight: 500 !important;
}

.text-subtitle-2.primary--text {
  color: rgba(26, 26, 26, 0.85) !important;
}

.secondary--text {
  color: var(--v-secondary-base) !important;
}

.white--text {
  color: #e0e0e0 !important;
}

/* Avatares */
::v-deep .v-avatar {
  border: 2px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  transition: all 0.3s ease;
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3);
}

::v-deep .v-card:hover .v-avatar {
  transform: rotate(5deg) scale(1.1);
  border-color: var(--v-secondary-base);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
}

::v-deep .v-avatar .v-icon {
  color: var(--v-secondary-base) !important;
  filter: drop-shadow(0 4px 12px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4));
}

/* Imágenes */
::v-deep .v-image {
  border-radius: 8px;
  border: 2px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  transition: all 0.3s ease;
}

::v-deep .v-card:hover .v-image {
  border-color: var(--v-secondary-base);
  transform: scale(1.05);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
}

/* Botones */
::v-deep .v-btn {
  border-radius: 12px !important;
  text-transform: none !important;
  font-weight: 600 !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
  position: relative;
  overflow: hidden;
}

::v-deep .v-btn::before {
  content: '';
  position: absolute;
  top: 50%;
  left: 50%;
  width: 0;
  height: 0;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  transform: translate(-50%, -50%);
  transition: width 0.6s, height 0.6s;
  pointer-events: none;
}

::v-deep .v-btn:active::before {
  width: 300px;
  height: 300px;
}

::v-deep .v-btn:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6) !important;
}

::v-deep .v-btn.secondary,
::v-deep .v-btn[color='secondary'] {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-base) 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 16px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4) !important;
}

/* Botones de búsqueda modernos */
.btn-search-modern,
.btn-new-search {
  background: linear-gradient(135deg, var(--v-secondary-base) 0%, var(--v-secondary-lighten1) 100%) !important;
  color: #1a1a1a !important;
  font-weight: 700 !important;
  letter-spacing: 0.5px;
  text-transform: none !important;
  box-shadow: 0 6px 20px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4) !important;
  transition: all 0.3s cubic-bezier(0.175, 0.885, 0.32, 1.275) !important;
}

.btn-search-modern:hover:not(:disabled),
.btn-new-search:hover {
  transform: translateY(-3px);
  box-shadow: 0 10px 30px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6) !important;
}

.btn-search-modern:active,
.btn-new-search:active {
  transform: translateY(-1px);
}

::v-deep .v-btn.primary {
  background: rgba(26, 46, 36, 0.8) !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
}

::v-deep .v-btn.primary:hover {
  background: rgba(26, 46, 36, 0.95) !important;
  border-color: var(--v-secondary-base);
}

/* Botones en card-actions */
::v-deep .v-card-actions .v-btn {
  background: linear-gradient(135deg, rgba(26, 26, 26, 0.9) 0%, rgba(15, 15, 15, 0.95) 100%) !important;
  color: var(--v-secondary-base) !important;
  border: 2px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4) !important;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.3) !important;
}

::v-deep .v-card-actions .v-btn:hover {
  background: linear-gradient(135deg, rgba(15, 15, 15, 0.95) 0%, rgba(5, 5, 5, 1) 100%) !important;
  border-color: var(--v-secondary-base) !important;
  color: #ffffff !important;
  box-shadow: 0 8px 24px rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6) !important;
}

::v-deep .v-card-actions .v-btn .v-icon {
  color: var(--v-secondary-base) !important;
}

::v-deep .v-card-actions .v-btn:hover .v-icon {
  color: #ffffff !important;
}

::v-deep .v-btn:disabled {
  opacity: 0.5 !important;
}

::v-deep .v-btn .v-icon {
  transition: all 0.3s ease;
}

::v-deep .v-btn:hover .v-icon {
  transform: scale(1.2);
}

/* Input fields */
::v-deep .v-text-field .v-input__slot {
  background: transparent !important;
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.2) !important;
  border-radius: 12px !important;
  transition: all 0.3s ease !important;
}

::v-deep .v-text-field .v-input__slot:hover {
  border-color: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3) !important;
}

::v-deep .v-input--is-focused .v-input__slot {
  border-color: var(--v-secondary-base) !important;
  box-shadow: none !important;
  background: transparent !important;
}

::v-deep .v-text-field__slot input {
  color: #e0e0e0 !important;
}

::v-deep .v-text-field__slot label {
  color: rgba(224, 224, 224, 0.6) !important;
}

::v-deep .v-input--is-focused .v-text-field__slot label {
  color: var(--v-secondary-base) !important;
}

/* Tooltips */
::v-deep .v-tooltip__content {
  background: rgba(26, 46, 36, 0.95) !important;
  backdrop-filter: blur(10px);
  border: 1px solid rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.3);
  border-radius: 8px;
  color: #e0e0e0 !important;
  font-weight: 500;
  padding: 8px 12px;
}

/* Semáforo */
::v-deep .v-chip {
  border-radius: 8px;
  transition: all 0.3s ease;
}

/* Scrollbar */
::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

::-webkit-scrollbar-track {
  background: rgba(10, 10, 10, 0.5);
  border-radius: 4px;
}

::-webkit-scrollbar-thumb {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.4);
  border-radius: 4px;
  transition: background 0.3s;
}

::-webkit-scrollbar-thumb:hover {
  background: rgba(var(--v-secondary-base-rgb, 255, 165, 2), 0.6);
}

.fab {
  position: fixed;
  bottom: 24px;
  right: 24px;
}
</style>
